<script setup>
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'

const { t } = useI18n()
const uiStore = useUiStore()

function setResultFilter(newFilter) {
  uiStore.setResultFilter(newFilter)
  uiStore.setCclDocumentFilter("")
}

function setCclDocumentFilter(newFilter) {
  uiStore.setCclDocumentFilter(newFilter)
  uiStore.setResultFilter("")
}

</script>

<template>

  <!-- LEFT COLUMN: Result filters-->
  <div class="row mleft-02 gap-03 flexwrap mleft-15">
    <switchGroup styles="padButton-s" :active="uiStore.resultFilter === 'Lab'" @click="setResultFilter('Lab')">
      <text-item :txt="t('patient.filters.bio')" :class="uiStore.resultFilter === 'Lab' ? 'txt-white' : 'txt-primary'" styles="font-mBold"/>
    </switchGroup>
    <switchGroup styles="padButton-s" :active="uiStore.resultFilter === 'Imaging'" @click="setResultFilter('Imaging')">
      <text-item :txt="t('patient.filters.imaging')" :class="uiStore.resultFilter === 'Imaging' ? 'txt-white' : 'txt-primary'" styles="font-mBold"/>
    </switchGroup>
    <switchGroup styles="padButton-s" :active="uiStore.resultFilter === 'OtherTests'" @click="setResultFilter('OtherTests')">
      <text-item :txt="t('patient.filters.other')" :class="uiStore.resultFilter === 'OtherTests' ? 'txt-white' : 'txt-primary'" styles="font-mBold"/>
    </switchGroup>
  </div>

  <!-- SPACER -->
  <div></div>

  <!-- RIGHT COLUMN: Conclusion filters -->
  <div class="row gap-03 flexwrap mleft-25">
    <switchGroup styles="padButton-s" :active="uiStore.cclDocumentFilter === 'Report'" @click="setCclDocumentFilter('Report')">
      <text-item :txt="t('patient.filters.reports')" :class="uiStore.cclDocumentFilter === 'Report' ? 'txt-white' : 'txt-primary'" styles="font-mBold"/>
    </switchGroup>
    <switchGroup styles="padButton-s" :active="uiStore.cclDocumentFilter === 'Request'" @click="setCclDocumentFilter('Request')">
      <text-item :txt="t('patient.filters.requests')" :class="uiStore.cclDocumentFilter === 'Request' ? 'txt-white' : 'txt-primary'" styles="font-mBold"/>
    </switchGroup>
  </div>

</template>